import { render } from "./Logo.vue?vue&type=template&id=00f2c2b0&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=00f2c2b0&scoped=true&lang=scss"

import exportComponent from "E:\\work9\\wzbz_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f2c2b0"]])

export default __exports__